import { isDemoMode } from '../auth/PasswordGate';

// Stable email → person mapping. Mirrors the hardcoded admin email in
// config/admin.ts. The internal 'dakota'/'natalia' keys never change.
const PERSON_EMAILS: Record<'dakota' | 'natalia', string> = {
  dakota: 'dakotaberg@gmail.com',
  natalia: 'nataliamberg@gmail.com',
};

export function emailToPerson(
  email: string | null | undefined
): 'dakota' | 'natalia' | null {
  const e = (email ?? '').toLowerCase();
  if (e === PERSON_EMAILS.dakota) return 'dakota';
  if (e === PERSON_EMAILS.natalia) return 'natalia';
  return null;
}

// Display names for the two household members. Demo mode swaps both for
// generic placeholders so screen recordings don't expose real first names.
// The internal model keys ('dakota'/'natalia') stay unchanged — only the
// rendered text differs.
const REAL: Record<'dakota' | 'natalia', string> = {
  dakota: 'Dakota',
  natalia: 'Natalia',
};
const DEMO: Record<'dakota' | 'natalia', string> = {
  dakota: 'Alex',
  natalia: 'Sam',
};

export function getPersonName(person: 'dakota' | 'natalia'): string {
  return (isDemoMode() ? DEMO : REAL)[person];
}

export function dakotaName(): string {
  return getPersonName('dakota');
}

export function nataliaName(): string {
  return getPersonName('natalia');
}
